module.exports = __webpack_public_path__ + "media/images/arrow-up-icon-2591bfa5bc8b4a0cd7eb4e8b4c8f3d050f90c1e982ba80f65d9d51b3e201d4d7.svg";